
import React from 'react'
import { each, get, reduce, has } from 'lodash'
import esDictionary from '../i18n/es'

const withTranslation = (WrappedComponent, keys) => {
    class TranslationComponent extends React.PureComponent {
        translatedProps () {
            let _results = {}
            each(keys, (key) => {
                if (has(this.props, key)) {
                    _results[key] = reduce([this.props[key], `${key}:${get(this.props, key)}`], (acc, label) => {
                        acc = get(esDictionary, label, acc)
                        return acc
                    }, this.props[key])
                }
            });

            return Object.assign({...this.props}, _results);
        }

        render () {
            const props = this.translatedProps();

            return <WrappedComponent {...props} />
        }
    }

    return TranslationComponent
}

export default withTranslation
